import { PlusOutlined } from '@ant-design/icons';
import { Card, Modal, Skeleton, Space, Spin, Upload, message } from 'antd';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { IoDocumentTextOutline } from 'react-icons/io5';

import './Order.less';

/**
 * Тооллогын баримт (зураг) — Хүргэлтийн захиалгын Баримт табтай
 * (orderDelivery/ListWithDetail/Fact.js) ижил Card хэв маягтай.
 */
const Facts = ({ facts = {}, loading = false, getDetailData }) => {
  const [fileList, setFileList] = useState([]);
  // Зураг хуулах/устгах хүсэлт явж байх үед
  const [fileSaving, setFileSaving] = useState(false);

  useEffect(() => {
    // Дата ачаалагдаагүй байхад (?tab=fact-аар шууд орох) images байхгүй байж болно
    const uploadedFiles = (facts?.images ?? []).map((image) => ({ url: image }));
    if (facts?.signature) uploadedFiles.push({ url: facts.signature });
    setFileList(uploadedFiles);
  }, [facts]);

  /**
   * Зургийг шууд устгахгүй — хэрэглэгчээс баталгаажуулна. Promise `false`-аар
   * шийдэгдвэл Upload зургийг жагсаалтаас хасахгүй, onChange ч дуудагдахгүй.
   */
  const confirmRemove = () =>
    new Promise((resolve) => {
      Modal.confirm({
        title: 'Зургийг устгах уу?',
        okText: 'Устгах',
        cancelText: 'Болих',
        okButtonProps: { danger: true },
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

  const uploadProps = {
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    onRemove: () => confirmRemove(),
    fileList,
  };

  const handleUpload = async ({ file }) => {
    const formData = new FormData();
    fileList.forEach((item) => {
      formData.append('files[]', item);
    });

    try {
      const { data } = await axios.post(
        `${
          process.env.REACT_APP_STORAGE_URL
        }/upload/operator/merchant?fileName=image${Date.now()}&uid=${file.uid}`,
        formData
      );

      if (data.statusCode === 200) {
        await axios.post('/api/v1.0/request/uploadInventoryFile', {
          code: facts?.code,
          image: data?.result?.location,
        });
        getDetailData?.(facts?._id);
        setFileList([]);
        message.success('Зургийг амжилттай хадгаллаа.');
      }
    } catch (error) {
      // Алдааны мэдэгдлийг axios interceptor аль хэдийн гаргасан — давхардуулахгүй
      console.error('uploadInventoryFile: ', error);
    }
  };

  const removeFile = async ({ file }) => {
    const { data } = await axios.post('/api/v1.0/request/removeInventoryFile', {
      code: facts?.code,
      image: file.url,
    });
    if (data.statusCode === 200) {
      message.success('Зургийг амжилттай устгалаа.');
      getDetailData?.(facts?._id);
    }
  };

  const onChangeFile = async ({ file }) => {
    setFileSaving(true);
    try {
      if (file?.status === 'removed') {
        await removeFile({ file });
      } else {
        await handleUpload({ file });
      }
    } finally {
      setFileSaving(false);
    }
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div className="upload_btn_text">Зураг оруулах</div>
    </div>
  );

  return (
    <Space direction="vertical" size={16} style={{ width: '100%', padding: 16 }}>
      <Card
        title={
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <IoDocumentTextOutline style={{ display: 'block', fontSize: '1em' }} />
            Баримт оруулах
          </span>
        }
        size="middle"
      >
        <div style={{ paddingInline: '1px', paddingBottom: '16px' }}>
          {loading ? (
            <Skeleton.Image active style={{ width: 102, height: 102 }} />
          ) : (
            <Spin spinning={fileSaving}>
              <Upload
                {...uploadProps}
                listType="picture-card"
                fileList={fileList}
                onChange={onChangeFile}
                disabled={fileSaving}
              >
                {uploadButton}
              </Upload>
            </Spin>
          )}
        </div>
      </Card>
    </Space>
  );
};

export default Facts;
